import { useState, useEffect } from 'react';
import { authApi } from '@/api-client';

export function useAuth() {
  const [authenticated, setAuthenticated] = useState<boolean | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    authApi.check()
      .then(data => setAuthenticated(data.authenticated))
      .catch(() => setAuthenticated(false))
      .finally(() => setLoading(false));
  }, []);

  const login = async (password: string) => {
    const result = await authApi.login(password);
    if (result.success) {
      setAuthenticated(true);
      return true;
    }
    return false;
  };

  const logout = async () => {
    await authApi.logout();
    setAuthenticated(false);
  };

  return { authenticated, loading, login, logout };
}